import { useCallback, useState } from 'react';

const createNewObject = () => ({});

export default function useForceUpdate() {
  const [, setValue] = useState(createNewObject);

  return useCallback(() => {
    setValue(createNewObject());
  }, []);
}
